import { Component, EventEmitter, Input, Output, forwardRef, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';


@Component({
	selector: 'bb-position',
	templateUrl: './bb-position.component.html',
	styleUrls: ['./bb-position.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbPositionComponent),
		multi: true
	}]

})

export class BbPositionComponent implements ControlValueAccessor, OnInit, OnChanges {

	@Input() formControl: UntypedFormControl;
	@Input() positions: any;

	@Output() onPositionChange = new EventEmitter<string>();

	propagateChange: any;
	positionModel: any = { value: '' };

	constructor() {
		if (!this.positions) {
			this.positions = [
				['top left', 'top center', 'top right'],
				['center left', 'center', 'center right'],
				['bottom left', 'bottom center', 'bottom right']
			];
		}
	}

	ngOnInit() { }

	ngOnChanges(changes: SimpleChanges) { }

	valueChanged(position: any) {
		this.onPositionChange.emit(position);
		this.propagateChange(position);
	}

	clicked() {

	}

	writeValue(value: string) {
		this.positionModel.value = value;
	}

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() {

	}
}
